import React from 'react';
import '../styles/workflow-overlay.css';
import { projectOverlayData } from '../sources/projectOverlayData';

const WorkflowOverlay = ({ project, onClose }) => {
  // Get project data from centralized source
  const projectData = projectOverlayData[project.title];

  // Render section based on type
  const renderSection = (section, index) => {
    // Overview section with stats
    if (section.stats) {
      return (
        <section key={index} className="workflow-section">
          <h2>{section.title}</h2>
          <p>{section.content}</p>
          <div className="stats-row">
            {section.stats.map((stat, i) => (
              <div key={i} className="stat-item">
                <span className="stat-label">{stat.label}</span>
                <span className="stat-value">{stat.value}</span>
              </div>
            ))}
          </div>
        </section>
      );
    }

    // Workflow steps (ordered list)
    if (section.type === 'steps') {
      return (
        <section key={index} className="workflow-section">
          <h2>{section.title}</h2>
          <ol className="workflow-steps">
            {section.steps.map((step, i) => (
              <li key={i}>
                <strong>{step.title}</strong>
                <p>{step.description}</p>
              </li>
            ))}
          </ol>
        </section>
      );
    }

    // Tech list (grid layout)
    if (section.type === 'tech-list') {
      return (
        <section key={index} className="workflow-section">
          <h2>{section.title}</h2>
          <ul className="tech-list">
            {section.items.map((item, i) => (
              <li key={i}>
                <strong>{item.name}</strong> - {item.description}
              </li>
            ))}
          </ul>
        </section>
      );
    }

    // Simple list
    if (section.type === 'list') {
      return (
        <section key={index} className="workflow-section">
          <h2>{section.title}</h2>
          <ul className="simple-list">
            {section.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>
      );
    }

    // Default: just title and content
    return (
      <section key={index} className="workflow-section">
        <h2>{section.title}</h2>
        <p>{section.content}</p>
      </section>
    );
  };

  // Render content based on project data
  const renderProjectContent = () => {
    // If project has custom overlay data
    if (projectData && projectData.sections) {
      return projectData.sections.map((section, index) => renderSection(section, index));
    }

    // Default content for projects without custom overlay
    return (
      <section className="workflow-section">
        <h2>Project Details</h2>
        <p>{project.description}</p>
        <div className="tags-list">
          {project.tags.map((tag, i) => (
            <span key={i} className="tag">{tag}</span>
          ))}
        </div>
      </section>
    );
  };

  return (
    <div className="workflow-overlay">
      <div className="workflow-content">
        <div className="workflow-header">
          <button className="workflow-close-btn" onClick={onClose}>
            ✕
          </button>
          <h1>{project.title}</h1>
          <p className="subtitle">{project.description}</p>
        </div>

        <div className="workflow-body">
          {renderProjectContent()}
        </div>
      </div>
    </div>
  );
};

export default WorkflowOverlay;
